import { getQuestionShortIds } from 'store/settings/selectors';

class IdMapper {
  initialize(state, { useShortIds } = { userShortIds: false }) {
    this.useShortIds = useShortIds;
    this.questionShortIds = getQuestionShortIds(state);
  }

  map(questionId) {
    return this.useShortIds ? this.questionShortIds[questionId].toString() : questionId;
  }

  unMap(questionId) {
    if (!this.useShortIds) {
      return questionId;
    }

    return Object.keys(this.questionShortIds).find(
      key => this.questionShortIds[key].toString() === questionId
    );
  }
}

export default new IdMapper();
